import request from '@/utils/request'
// VUE_APP_BASE_API  5010
// VUE_APP_SN_API 5012
// 人员规模统计
export function getStaffSizeChart(data) {
    return request({
        url: '/v1/WebStats/GetCountStatsOfPersonnelScaleV1',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 创立年限
export function getEstablishmentPeriodChart(data) {
    return request({
        url: '/v1/WebStats/GetCountStatsOfYearV1',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 上市挂牌企业
export function getListedCompaniesChart(data) {
    return request({
        url: 'v1/WebStats/GetCountStatsOfStockV2',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 优质中小企业
export function getHighQualityEnterpriseChart(data) {
    return request({
        url: 'v1/WebStats/GetCompanyXJREntOfTagV1',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 科技资质统计
export function getTechnologyQualificationsChart(data) {
    return request({
        url: 'v1/WebStats/GetCountStatsOfStockV2',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 办件排名统计 
export function getHandlingDocuments(data) {
    return request({
        url: 'ProcessingStatistics/GetProcessingRanking',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}
// 行业分布 
export function getIndustryCountData(data) {
    return request({
        url: 'v1/WebStats/GetIndustryCountData',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}
// 星级评价统计
export function getStarRating(data) {
    return request({
        url: '/ProcessingStatistics/GetStarRanking',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 全区办件总数
export function getTotalProcessingRanking(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalProcessingRanking',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 全区优质企业数量
export function getTotalHighQualityEnterpriseNum(data) {
    return request({
        url: '/v1/WebStats/SearchCustomerList?typeId=3',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 获取企业列表
export function searchCustomerList(data) {
    return request({
        url: '/v1/WebStats/SearchCustomerList?typeId=3',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 获取开福区热力图
export function getHeatMap(data) {
    return request({
        url: '/v1/WebStats/GetKaiFuHotDta',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 平台用户数
export function getTotalUserCount(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalUserCount',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业数
export function getTotalAuthenticatedEnterpriseCount(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalAuthenticatedEnterpriseCount',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业行业分布 TOP5（Dashboard）
export function getAuthenticatedEnterpriseIndustryTop5() {
    return request({
        url: '/ProcessingStatistics/GetAuthenticatedEnterpriseIndustryTop5',
        method: 'get',
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业行业分布全部（查看更多）
export function getAuthenticatedEnterpriseIndustryAll() {
    return request({
        url: '/ProcessingStatistics/GetAuthenticatedEnterpriseIndustryAll',
        method: 'get',
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 日访问量
export function getTotalVisits(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalVisits',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 今日全区办件总量
export function getTotalProcessingRankingAndToday(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalProcessingRankingAndToday',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 衡企名片企业数 
export function getTotalEnterpriseCount(data) {
    return request({
        url: '/v1/WebStats/SearchCustomerListCount',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 功能模块活跃度
export function getSysVisits(data) {
    return request({
        url: '/Visits/GetSysVisits',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 活跃度变化趋势
export function getHomeVisitsByTimeSpan(data) {
    return request({
        url: '/ProcessingStatistics/GetHomeVisitsByTimeSpan',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}
//获取行业
export function getIndustryTreeData(data) {
    return request({
        url: '/v1/CountryIndustry/GetIndustryTreeData',
        method: 'get',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 新增注册企业统计数据
export function GetRegisteredCompanyCountOfMonth(data) {
    return request({
        url: '/v1/WebIndustrialChain/GetRegisteredCompanyCountOfMonth',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}
// 获取指定月数的注销企业统计数据
export function GetClosedCompanyCountOfMonth(data) {
    return request({
        url: '/v1/WebIndustrialChain/GetClosedCompanyCountOfMonth',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 获取指定月数的迁出企业统计数据
export function GetMoveOutCompanyCountOfMonth(data) {
    return request({
        url: '/v1/WebIndustrialChain/GetMoveOutCompanyCountOfMonth',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 获取福企名片企业列表
export function SearchCustomerList(data) {
    return request({
        url: 'v1/WebStats/SearchCustomerList?typeId=3',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业地域分布
export function GetAreaAuthenticatedEnterpriseCount(data) {
    return request({
        url: 'ProcessingStatistics/GetAreaAuthenticatedEnterpriseCount',
        method: 'get',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业地域访问量 TOP5
export function GetVisitsAreaUser(data) {
    return request({
        url: '/Visits/GetVisitsAreaUser',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 注册用户增长趋势
export function GetTotalLoginUserCount(data) {
    return request({
        url: '/ProcessingStatistics/GetTotalLoginUserCount',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业增长趋势
export function GetNewCompanyCount(data) {
    return request({
        url: '/ProcessingStatistics/GetNewCompanyCount',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 活跃度变化趋势
export function GetHomeVisitsByTimeSpan(data) {
    return request({
        url: '/ProcessingStatistics/GetHomeVisitsByTimeSpan',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 政府用户数
export function GetTotalUserByType(params) {
    return request({
        url: '/ProcessingStatistics/GetTotalUserByType',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 诉求统计
export function GetDemandStatisticsList(params) {
    return request({
        url: '/Demand/GetDemandStatisticsList',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 投诉统计
export function GetComplaintsStatisticsList(params) {
    return request({
        url: '/ComplaintsReport/GetComplaintsStatisticsList',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 政府用户部门分布统计
export function GetDepUserCount(params) {
    return request({
        url: '/ProcessingStatistics/GetDepUserCount',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 衡优享服务 - 景区游览数量（HyContactList）
export function GetHyContactList(data) {
    return request({
        url: '/HyContactList/Load',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 衡优享服务 - 医疗/交通/教育数量
export function GetCheckStatistics(params) {
    return request({
        url: '/ServiceCheck/GetCheckStatistics',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 活跃度变化趋势 - 用户访问详情
export function GetUserVisitsInfo(data) {
    return request({
        url: '/Visits/GetUserVisitsInfo',
        method: 'post',
        data,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 认证企业增长趋势 - 新增认证企业详情
export function GetNewCompanyDetailList(params) {
    return request({
        url: '/UserBingCompany/GetNewCompanyDetailList',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 医疗就医 - 医院记录列表
export function GetAllHospitalRecords(params) {
    return request({
        url: '/ServiceCheck/AllHospitalRecords',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 医疗就医 - 导出医院记录
export function ExportAllHospitalRecords(params) {
    return request({
        url: '/ServiceCheck/ExportAllHospitalRecords',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 医疗就医 - 类型字典
export function GetListByTypeId(params) {
    return request({
        url: '/Categorys/GetListByTypeId',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}

// 交通出行 - 交通记录列表
export function GetAllTransportationRecords(params) {
    return request({
        url: '/ServiceCheck/AllTransportationRecords',
        method: 'get',
        params,
        baseURL: process.env.VUE_APP_SN_API
    })
}
